import {
    Box,
    Card,
    CardContent,
    LinearProgress,
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow,
    Typography,
} from '@mui/material';
import {DashboardEmployee} from '../../../state/types/Dashboard';

const formatCurrency = (cents: number): string => {
    return (cents / 100).toLocaleString('de-DE', { style: 'currency', currency: 'EUR' });
};

interface RevenueByEmployeeTableProps {
    employees: DashboardEmployee[];
    totalHours: number;
}

const RevenueByEmployeeTable = (props: RevenueByEmployeeTableProps) => {
    const maxHours = Math.max(...props.employees.map(e => e.totalHours), 1);

    return (
        <Card sx={{ height: '100%' }}>
            <CardContent>
                <Typography variant={'h6'} sx={{ marginBottom: 2 }}>
                    Umsatz nach Mitarbeiter
                </Typography>
                <TableContainer>
                    <Table size={'small'}>
                        <TableHead>
                            <TableRow>
                                <TableCell>Mitarbeiter</TableCell>
                                <TableCell align={'right'}>Stunden</TableCell>
                                <TableCell align={'right'}>Umsatz</TableCell>
                                <TableCell width={'30%'}>Anteil</TableCell>
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            {props.employees.map((emp) => (
                                <TableRow key={emp.userId}>
                                    <TableCell>{emp.name}</TableCell>
                                    <TableCell align={'right'}>{emp.totalHours.toFixed(2)} h</TableCell>
                                    <TableCell align={'right'}>{formatCurrency(emp.totalRevenue)}</TableCell>
                                    <TableCell>
                                        <Box sx={{ display: 'flex', alignItems: 'center' }}>
                                            <LinearProgress
                                                variant={'determinate'}
                                                value={(emp.totalHours / maxHours) * 100}
                                                sx={{
                                                    width: '100%',
                                                    height: 8,
                                                    borderRadius: 4,
                                                    backgroundColor: 'rgba(0, 106, 124, 0.1)',
                                                    '& .MuiLinearProgress-bar': {
                                                        borderRadius: 4,
                                                    },
                                                }}
                                            />
                                        </Box>
                                    </TableCell>
                                </TableRow>
                            ))}
                            {props.employees.length === 0 && (
                                <TableRow>
                                    <TableCell colSpan={4} align={'center'}>
                                        <Typography color={'text.secondary'}>
                                            Keine Daten vorhanden
                                        </Typography>
                                    </TableCell>
                                </TableRow>
                            )}
                        </TableBody>
                    </Table>
                </TableContainer>
            </CardContent>
        </Card>
    );
};

export default RevenueByEmployeeTable;
